import { BreadCrumbs, Text } from '@carnica/ui-kit';
import { connect } from 'react-redux';

import {
  selectBreadcrumbsContent,
  selectNewsDate,
  selectTabsContent,
} from 'pages/News/NewsDetails/store/selectors';
import { RootState } from 'pages/News/NewsDetails/store';
import { formatDate } from 'pages/News/NewsPage/utils/date';

import { NewsLabelsList } from '../../SharedComponents';

export const LCBreadCrumbs = connect((state: RootState) => ({
  items: selectBreadcrumbsContent(state),
}))(BreadCrumbs);

export const LCNewsLabels = connect((state: RootState) => ({
  labels: selectTabsContent(state),
  size: 'm',
}))(NewsLabelsList);

export const NewsDate = connect((state: RootState) => ({
  children: formatDate(selectNewsDate(state)),
  color: 'secondary',
  variant: 'body-small',
}))(Text);

export * from './LatestNewsBlock';
export * from './ContentContainer';
export * from './ContentDetails';
